import { render } from "./PersonalCloudSpace.vue?vue&type=template&id=3a4cfcaf&scoped=true"
import script from "./PersonalCloudSpace.vue?vue&type=script&lang=ts"
export * from "./PersonalCloudSpace.vue?vue&type=script&lang=ts"

import "./PersonalCloudSpace.vue?vue&type=style&index=0&id=3a4cfcaf&lang=scss&scoped=true"
import "./PersonalCloudSpace.vue?vue&type=style&index=1&id=3a4cfcaf&lang=scss"
script.render = render
script.__scopeId = "data-v-3a4cfcaf"

export default script